import { render, staticRenderFns } from "./AditionalServices.vue?vue&type=template&id=7191f2ce&scoped=true&"
import script from "./AditionalServices.vue?vue&type=script&lang=js&"
export * from "./AditionalServices.vue?vue&type=script&lang=js&"
import style0 from "./AditionalServices.vue?vue&type=style&index=0&id=7191f2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7191f2ce",
  null
  
)

export default component.exports